import {Renderer} from 'pixi.js';
import {DrawCallsPanel, FPSPanel, GPUMemoryPanel, Stats, TexturesPanel} from './stats';

export class DebugStats {
    private _stats!: Stats;

    public init(renderer: Renderer): void {
        this._stats = new Stats({ gl: renderer.gl, renderStep: 500, id: 'debugStats' });

        this._stats.addPanel(new FPSPanel());
        this._stats.addPanel(new DrawCallsPanel());
        this._stats.addPanel(new TexturesPanel());
        this._stats.addPanel(new GPUMemoryPanel());
    }

    public update(): void {
        this._stats.update();
    }

    public hide(): void {
        this._stats.hide();
    }

    public show(): void {
        this._stats.show();
    }

    public toggle(): void {
        this._stats.toggle();
    }

    public destroy(): void {
        this._stats.destroy();
    }
}
